import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let GanttChartInfoComponent = {
    selector: "vcGanttChartInfo",
    templateUrl:
        "/angular/components/planner/gantt-chart/gantt-chart-info.component.html",
    bindings: {},
    controller: class GanttChartInfoController {
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        close(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("planner")
    .component(GanttChartInfoComponent.selector, GanttChartInfoComponent);
